import { Reducer } from "redux";
import { TableauAction, TableauActionTypes } from "../Actions/TableauActions";
import { IAction, ITableauView, ITableau } from "../Models/Models";

const InitialContainerState: ITableau = {
    views: [],
    loading: true,
};

export const tableauReducer = (
    state: ITableau = InitialContainerState,
    action: TableauAction
): ITableau => {
    switch (action.type) {
        case TableauActionTypes.REQUEST_VIEWS:
            return { ...state, loading: true };
        case TableauActionTypes.VIEWS_LOADED:
            const viewsLoadedAction = action as IAction<ITableauView[]>;
            return { ...state, views: viewsLoadedAction.payload, loading: false };
        default:
            return { ...state };
    }
};
